import { ref } from 'vue';
import { useNavigation } from './useNavigation';
import { useCommonData } from '@/hooks';

export const useSlide = () => {
	const { viewInIframe } = useCommonData();
	const { goToHome } = useNavigation();

	const pageMenus = ref([]);
	const setPageMenus = data => {
		pageMenus.value = data || [];
	};

	const activeMenuId = ref(null);
	const changeMenuActive = menu => {
		// 展示类型 1:跳转链接 2:模块
		if (menu.showType === 1) {
			return window.open(menu.menuUrl);
		}

		// 更新激活模块，同步双端路由参数
		renderActiveModule(menu.id);

		// 非iframe模式下，同步路由信息
		if (!viewInIframe.value) {
			goToHome({ muid: menu.id });
		}
	};

	const moduleList = ref([]);
	const activeModuleId = ref(null);

	const renderActiveModule = (menuId, moduleId = null) => {
		const menuList = pageMenus.value || [];
		const [fstMenu] = menuList; // 默认选中第一个菜单

		// 查uuid和菜单id
		const findMenu = menuList.find(item => item.id == menuId || item.__id == menuId) || fstMenu;
		activeMenuId.value = findMenu.id;

		const moduleVOS = findMenu.moduleVOS || [];
		const [fstModule] = moduleVOS; // 默认激活第一个模块

		// 模块选中同步
		moduleList.value = moduleVOS;
		const findActiveModule = moduleVOS.find(item => item.moduleId == moduleId) || fstModule;
		activeModuleId.value = findActiveModule?.moduleId;
	};

	const getMenuLogo = menu => {
		const svgReg = new RegExp(/\/([^/.]+)\.svg$/);
		const match = menu?.menuLogo?.match(svgReg);
		if (match) {
			const result = match[1];
			// `assets/icons/tab_xxx.svg`
			return `tab_${result}`;
		}
		return '';
	};

	return {
		pageMenus,
		setPageMenus,

		activeMenuId,
		changeMenuActive,

		moduleList,
		activeModuleId,

		renderActiveModule,
		getMenuLogo
	};
};
